<template>
  <div id="save-as-pdf">
    <HeadersDetalhesResumo
      :apelido="imovel.apelido"
      :proprietario="imovel.proprietario"
      :tipo="imovel.tipo"
      :savoynet="imovel.savoynet"
    >
    </HeadersDetalhesResumo>
    <slick ref="slick" :options="slickOptions" v-if="ilustrativas.length > 0" class="hide-pdf">
      <img v-for="(item, index) in ilustrativas" :src="item.foto" height="350">
    </slick>
    <template v-if="showVistoriaColumn || $hasGranularPermission('tarefas', 'view')">
      <v-subheader>Vistoria e Tarefas</v-subheader>
      <v-layout row class="vistoria-tarefas-layout">
      <v-flex xs12 md6 class="px-5" v-if="showVistoriaColumn">
        <v-card flat v-if="showVistoriaEmptyState">
          <v-card-text>
            <v-icon class="mr-2">schedule</v-icon>
            <span class="subheading">Sem vistoria agendada</span>
          </v-card-text>
          <v-card-text class="pt-0 pb-3" v-if="canAddVistoria">
            <v-btn outline large class="mx-0 secondary secondary--text" :to="({ name: 'VistoriaAdicionar', params: { id: $route.params.id } })">Agendar vistoria</v-btn>
          </v-card-text>
        </v-card>
        <v-card flat v-else-if="canShowVistoriaCard">
          <v-card-text>
            <div>
              <span>
                <v-icon>schedule</v-icon>
                <VistoriaSituacao :situacao="vistoria.situacao" :key="vistoria.data" class="mr-5" v-if="vistoria.data_formatada">{{ vistoria.data_formatada }}</VistoriaSituacao>
              </span>
              <span>
                <VistoriaSituacao :situacao="vistoria.situacao" :key="vistoria.data"></VistoriaSituacao>
              </span>
              <div class="mt-2" v-if="vistoria.recorrencia">
                {{ vistoria.recorrencia_formatada }}
              </div>
              <div>
                <span class="grey--text">{{ vistoriaUserName() }}</span>
              </div>
              <div class="mt-3 mb-1" v-if="vistoria.observacoes">
                {{ vistoria.observacoes }}
              </div>
            </div>
          </v-card-text>
          <v-card-text class="pt-0 pb-3" v-if="canCompleteVistoria">
            <VistoriaRealizar :vistoriaId="vistoria.id" :imovelId="$route.params.id"></VistoriaRealizar>
          </v-card-text>
        </v-card>
      </v-flex>
      <div class="borda_imoveis" v-if="showVistoriaColumn && $hasGranularPermission('tarefas', 'view')"></div>
      <v-flex xs12 md6 class="px-5" v-if="$hasGranularPermission('tarefas', 'view')">
        <v-card flat v-if="tarefas.length < 1">
          <v-card-text>
            <v-layout row wrap>
              <div>
                <v-icon class="mr-2">event_available</v-icon>
                <span class="subheading">Sem tarefas agendadas</span>
              </div>
            </v-layout>
          </v-card-text>
          <v-card-text class="pt-0 pb-3" v-if="canAddTask">
            <v-btn outline large class="mx-0 secondary secondary--text" :to="({ name: 'TarefasAdicionar', params: { id: $route.params.id } })">Agendar tarefa</v-btn>
          </v-card-text>
        </v-card>
        <v-card flat v-for="(item, index) in tarefas" :key="item.id">
          <v-card-text>
            <div>
              <span>
                <v-icon>event_available</v-icon>
                <TarefasSituacao :data="item.data" :realizada="item.realizada" :key="index" class="mr-5" v-if="item.data_formatada">{{ item.data_formatada }}</TarefasSituacao>
              </span>
              <span>
                <TarefasSituacao :data="item.data" :realizada="item.realizada" :key="index"></TarefasSituacao>
              </span>
              <div class="mt-2">
                {{ item.tipo }}
              </div>
              <div>
                <span class="grey--text">{{ taskUserName(item) }}</span>
              </div>
            </div>
          </v-card-text>
          <v-card-text class="pt-0 pb-3" v-if="isTaskAssignedToCurrentUser(item)">
            <TarefasRealizar :tarefaId="item.id" :imovelId="$route.params.id"></TarefasRealizar>
          </v-card-text>
          <v-divider v-if="tarefas.length > index + 1"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
    </template>
    <v-subheader>Cadastro</v-subheader>
    <v-card flat v-if="coords.lat !== null && coords.lng !== null && $hasGranularPermission('endereco', 'view')" class="hide-pdf">
      <gmap-map
        v-if="coords.lat !== null && coords.lng !== null"
        :center="coords"
        :zoom="15"
        :options="{ clickableIcons: false, disableDoubleClickZoom: true, streetViewControl: false, mapTypeControl: true, zoomControl: false, fullscreenControl: false }"
        style="width: 100%; height: 460px; margin-bottom: 10px;"
      >
        <gmap-marker
          :position="coords"
          :icon="getIcon()"
          :clickable="false"
        >
        </gmap-marker>
      </gmap-map>
    </v-card>
    <v-card flat class="px-5" v-if="$hasGranularPermission('endereco', 'view')">
      <v-card-text>
        <v-layout row wrap>
          <div>
            <v-icon class="mr-2">room</v-icon>
          </div>
          <template v-if="!imovel.hasOwnProperty('endereco')">
            <strong>Endereço</strong>
          </template>
          <template v-else>
            <v-flex xs12 md6 class="pr-5">
              <p><strong>Endereço</strong></p>
              <p v-for="(item, index) in this.endereco" v-if="index !== 'observacoes' && index !== 'anexos'" :key="index">{{ item }}</p>
              <div v-if="this.loteamento">
                <v-divider class="mt-1 mb-3"></v-divider>
                <p><strong>Loteamento</strong></p>
                <p v-for="item in this.loteamento" :key="item.id">{{ item }}</p>
              </div>
            </v-flex>
            <div class="borda_imoveis" v-if="this.endereco.observacoes.length > 0 || this.endereco.anexos.length > 0"></div>
            <v-flex xs12 md6 class="pl-5">
              <div v-if="this.endereco.observacoes.length > 0" class="mb-2">
                <p class="mb-2"><strong>Observações</strong></p>
                <p class="mb-0" v-for="item in this.endereco.observacoes" :key="item.id"><span class="data">{{ item.data }}:</span> {{ item.conteudo }}</p>
              </div>
              <div v-if="this.endereco.anexos.length > 0" class="hide-pdf">
                <p class="mb-2"><strong>Anexos</strong></p>
                <v-layout row wrap class="arquivos_mosaico text-xs-center">
                  <v-flex xs6 sm3 md2 v-for="item in this.endereco.anexos" :key="item.id" class="mb-2">
                    <a :href="item.path" target="_blank"><FileIcon :filename="item.titulo" large></FileIcon></a>
                    <div>{{ (item.legenda ? item.legenda : item.titulo)  }}</div>
                    <div class="data">{{ item.data }}</div>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </template>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>  
    <v-card flat class="px-5" v-if="$hasGranularPermission('registro', 'view')">
      <v-card-text>
        <v-layout row wrap>
          <div>
            <v-icon class="mr-2">description</v-icon>
          </div>
          <template v-if="!imovel.hasOwnProperty('registro')">
            <strong>Registros / documentos</strong>
          </template>
          <template v-else>
            <v-flex xs12 md6 class="pr-5">
              <p><strong>Registros / documentos</strong></p>
              <p v-for="(item, index) in this.registro" v-if="index !== 'observacoes' && index !== 'anexos'" :key="index"><strong>{{ index }}:</strong> {{ item }}</p>
            </v-flex>
            <div class="borda_imoveis" v-if="this.registro.observacoes.length > 0 || this.registro.anexos.length > 0"></div>
            <v-flex xs12 md6 class="pl-5">
              <div v-if="this.registro.observacoes.length > 0" class="mb-2">
                <p class="mb-2"><strong>Observações</strong></p>
                <p class="mb-0" v-for="item in this.registro.observacoes" :key="item.id"><span class="data">{{ item.data }}:</span> {{ item.conteudo }}</p>
              </div>
              <div v-if="this.registro.anexos.length > 0" class="hide-pdf">
                <p class="mb-2"><strong>Anexos</strong></p>
                <v-layout row wrap class="arquivos_mosaico text-xs-center">
                  <v-flex xs6 sm3 md2 v-for="item in this.registro.anexos" :key="item.id" class="mb-2">
                    <a :href="item.path" target="_blank"><FileIcon :filename="item.titulo" large></FileIcon></a>
                    <div>{{ (item.legenda ? item.legenda : item.titulo)  }}</div>
                    <div class="data">{{ item.data }}</div>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </template>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
    <v-card flat class="px-5" v-if="$hasGranularPermission('area', 'view')">
      <v-card-text>
        <v-layout row wrap>
          <div>
            <v-icon class="mr-2">filter_hdr</v-icon>
          </div>
          <template v-if="!imovel.hasOwnProperty('area')">
            <strong>Área</strong>
          </template>
          <template v-else>
            <v-flex xs12 md6 class="pr-5">
              <p><strong>Área</strong></p>
              <p v-for="(item, index) in this.area" v-if="item.length > 0 && index !== 'Calçada' && index !== 'Muro' && index !== 'observacoes' && index !== 'anexos'" :key="item.id">
                <strong>{{ index }}:</strong> {{ item }}
              </p>
              <p v-for="(item, index) in this.area" v-if="index === 'Calçada' || index === 'Muro'" :key="item.id">
                {{ item }} {{ index.toLowerCase() }}
              </p>
            </v-flex>
            <div class="borda_imoveis" v-if="this.area.observacoes.length > 0 || this.area.anexos.length > 0"></div>
            <v-flex xs12 md6 class="pl-5">
              <div v-if="this.area.observacoes.length > 0" class="mb-2">
                <p class="mb-2"><strong>Observações</strong></p>
                <p class="mb-0" v-for="item in this.area.observacoes" :key="item.id"><span class="data">{{ item.data }}:</span> {{ item.conteudo }}</p>
              </div>
              <div v-if="this.area.anexos.length > 0" class="hide-pdf">
                <p class="mb-2"><strong>Anexos</strong></p>
                <v-layout row wrap class="arquivos_mosaico text-xs-center">
                  <v-flex xs6 sm3 md2 v-for="item in this.area.anexos" :key="item.id" class="mb-2">
                    <a :href="item.path" target="_blank"><FileIcon :filename="item.titulo" large></FileIcon></a>
                    <div>{{ (item.legenda ? item.legenda : item.titulo)  }}</div>
                    <div class="data">{{ item.data }}</div>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </template>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
    <v-card flat class="px-5" v-if="$hasGranularPermission('taxas', 'view')">
      <v-card-text>
        <v-layout row wrap>
          <div>
            <v-icon class="mr-2">location_city</v-icon>
          </div>
          <template v-if="taxas.lista.length < 1">
            <strong>IPTU / impostos / taxas</strong>
          </template>
          <template v-else>
            <v-flex xs12 md6 class="pr-5">
              <p><strong>IPTU / impostos / taxas</strong></p>
              <div v-for="(item, index) in taxas.lista" :key="item.id">
                <p><strong>{{ item.taxa }}:</strong> {{ item.numero }}</p>
                <p v-if="item.situacao"><strong>Situação:</strong> {{ item.situacao }}</p>
                <p v-if="item.situacao === 'Pendente ajuizado' && item.ajuizado_cliente"><strong>Cliente/caso:</strong> {{ item.ajuizado_cliente }}</p>
                <p v-if="item.situacao === 'Pendente ajuizado' && item.ajuizado_processo"><strong>Processo/execução:</strong> {{ item.ajuizado_processo }}</p>
                <v-divider v-if="index + 1 < taxas.lista.length" :key="item.id" class="mb-3"></v-divider>
              </div>
            </v-flex>
            <div class="borda_imoveis" v-if="this.taxas.observacoes.length > 0 || this.taxas.anexos.length > 0"></div>
            <v-flex xs12 md6 class="pl-5">
              <div v-if="this.taxas.observacoes.length > 0" class="mb-2">
                <p class="mb-2"><strong>Observações</strong></p>
                <p class="mb-0" v-for="item in this.taxas.observacoes" :key="item.id"><span class="data">{{ item.data }}:</span> {{ item.conteudo }}</p>
              </div>
              <div v-if="this.taxas.anexos.length > 0" class="hide-pdf">
                <p class="mb-2"><strong>Anexos</strong></p>
                <v-layout row wrap class="arquivos_mosaico text-xs-center">
                  <v-flex xs6 sm3 md2 v-for="item in this.taxas.anexos" :key="item.id" class="mb-2">
                    <a :href="item.path" target="_blank"><FileIcon :filename="item.titulo" large></FileIcon></a>
                    <div>{{ (item.legenda ? item.legenda : item.titulo)  }}</div>
                    <div class="data">{{ item.data }}</div>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </template>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
    <v-card flat v-if="$hasGranularPermission('valor', 'view')" class="px-5">
      <v-card-text>
        <v-layout row wrap>
          <div>
            <v-icon class="mr-2">local_atm</v-icon>
          </div>
          <template v-if="!imovel.hasOwnProperty('valor')">
            <strong>Valor</strong>
          </template>
          <template v-else>
            <v-flex xs12 md6 class="pr-5">
              <p><strong>Valor</strong></p>
              <p v-for="(item, index) in this.valor" v-if="item.length > 0 && index !== 'observacoes' && index !== 'anexos'" :key="item.id"><strong>{{ index }}:</strong> {{ item }}</p>
            </v-flex>
            <div class="borda_imoveis" v-if="this.valor.observacoes.length > 0 || this.valor.anexos.length > 0"></div>
            <v-flex xs12 md6 class="pl-5">
              <div v-if="this.valor.observacoes.length > 0" class="mb-2">
                <p class="mb-2"><strong>Observações</strong></p>
                <p class="mb-0" v-for="item in this.valor.observacoes" :key="item.id"><span class="data">{{ item.data }}:</span> {{ item.conteudo }}</p>
              </div>
              <div v-if="this.valor.anexos.length > 0" class="hide-pdf">
                <p class="mb-2"><strong>Anexos</strong></p>
                <v-layout row wrap class="arquivos_mosaico text-xs-center">
                  <v-flex xs6 sm3 md2 v-for="item in this.valor.anexos" :key="item.id" class="mb-2">
                    <a :href="item.path" target="_blank"><FileIcon :filename="item.titulo" large></FileIcon></a>
                    <div>{{ (item.legenda ? item.legenda : item.titulo)  }}</div>
                    <div class="data">{{ item.data }}</div>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </template>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
    <v-card flat class="px-5" v-if="$hasGranularPermission('status', 'view')">
      <v-card-text>
        <v-layout row wrap>
          <div>
            <v-icon class="mr-2">check_circle</v-icon>
          </div>
          <template v-if="!imovel.hasOwnProperty('status')">
            <strong>Status</strong>
          </template>
          <template v-else>
            <v-flex xs12 md6 class="pr-5">
              <p><strong>Status</strong></p>
              <p class="subheading"><strong>{{ this.status.status }}</strong></p>
              <template
                v-for="(item, index) in this.status"
                v-if="item && index !== 'status' && index !== 'observacoes' && index !== 'anexos'"
              >
                <p v-if="/^divider.*/.test(index) === false && index !== 'Telefone'" :key="index">
                  <template v-if="index !== 'Placa' && index !== 'Condição' && index !== 'Índice'">
                    <strong>{{ index }}:</strong> {{ item }}
                  </template>
                  <template v-else-if="index === 'Índice'">
                    <strong>{{ index }}:</strong>
                    <span v-if="typeof item === 'number'" :class="{ 'red--text': item < 1 }">{{ item }}%</span>
                    <span v-else>{{ item }}</span>
                  </template>
                  <strong v-else>{{ item }}</strong>
                </p>
                <template v-else-if="index === 'Telefone'">
                  <p v-for="telefone in item" :key="item.id">
                    <strong :key="telefone.id">{{ index }}:</strong> {{ telefone.numero }}
                  </p>
                </template>
                <v-divider v-else :key="index" class="mt-1 mb-3"></v-divider>
              </template>
            </v-flex>
            <div class="borda_imoveis" v-if="this.status.observacoes.length > 0 || this.status.anexos.length > 0"></div>
            <v-flex xs12 md6 class="pl-5">
              <div v-if="this.status.observacoes.length > 0" class="mb-2">
                <p class="mb-2"><strong>Observações</strong></p>
                <p class="mb-0" v-for="item in this.status.observacoes" :key="item.id"><span class="data">{{ item.data }}:</span> {{ item.conteudo }}</p>
              </div>
              <div v-if="this.status.anexos.length > 0" class="hide-pdf">
                <p class="mb-2"><strong>Anexos</strong></p>
                <v-layout row wrap class="arquivos_mosaico text-xs-center">
                  <v-flex xs6 sm3 md2 v-for="item in this.status.anexos" :key="item.id" class="mb-2">
                    <a :href="item.path" target="_blank"><FileIcon :filename="item.titulo" large></FileIcon></a>
                    <div>{{ (item.legenda ? item.legenda : item.titulo)  }}</div>
                    <div class="data">{{ item.data }}</div>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </template>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
    <template v-if="$hasGranularPermission('observacoes', 'view')">
      <v-card flat class="px-5">
        <v-card-text>
          <v-layout row wrap>
            <div>
              <v-icon class="mr-2">assignment</v-icon>
            </div>
            <v-flex>
              <strong>Anotações</strong>
              <div class="mt-1" v-if="anotacoes.length > 0">
                <p class="mb-0" v-for="item in anotacoes" :key="item.id"><span class="data">{{ item.data }}:</span> {{ item.conteudo }}</p>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <div class="pt-0 pb-3 text-xs-center" v-if="$hasGranularPermission('observacoes', 'view')">
          <v-btn outline large class="secondary secondary--text" :to="({ name: 'ImoveisDetalhesObservacoes', params: { tipo: 'geral', id: $route.params.id } })">Abrir anotações</v-btn>
        </div>
        <v-divider></v-divider>
      </v-card>
    </template>
    <template v-if="$hasGranularPermission('anexos', 'view')">
      <v-card flat class="px-5 hide-pdf">
        <v-card-text>
          <v-layout row wrap>
            <div>
              <v-icon class="mr-2">cloud_upload</v-icon>
            </div>
            <v-flex>
              <strong>Anexos</strong>
              <v-layout row wrap class="arquivos_mosaico text-xs-center">
                <v-flex xs6 sm3 md2 v-for="item in anexos" :key="item.id" class="mt-2 mb-1">
                  <a :href="item.path" target="_blank"><FileIcon :filename="item.titulo" large></FileIcon></a>
                  <div>{{ (item.legenda ? item.legenda : item.titulo)  }}</div>
                  <div class="data">{{ item.data }}</div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <div class="py-3 text-xs-center" v-if="$hasGranularPermission('anexos', 'view')">
          <v-btn outline large class="secondary secondary--text" :to="({ name: 'ImoveisDetalhesAnexos', params: { tipo: 'geral', id: $route.params.id } })">Abrir arquivos</v-btn>
        </div>
        <v-divider></v-divider>
      </v-card>
    </template>
    <template v-if="$hasGranularPermission('fotos', 'view')">
      <v-card flat class="px-5 hide-pdf">
        <v-card-text>
          <v-layout row wrap>
            <div>
              <v-icon class="mr-2">add_a_photo</v-icon>
            </div>
            <v-flex>
              <strong>Fotos</strong>
              <v-layout row wrap class="arquivos_mosaico text-xs-center">
                <v-flex xs6 sm3 md2 v-for="item in fotos" :key="item.id" class="mt-2 mb-1">
                  <FileIcon :filename="item.titulo" large v-img="{ src: item.foto, title: item.titulo }"></FileIcon>
                  <div>{{ (item.legenda ? item.legenda : item.titulo)  }}</div>
                  <div class="data">{{ item.data }}</div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <div class="py-3 text-xs-center" v-if="$hasGranularPermission('fotos', 'view')">
          <v-btn outline large class="secondary secondary--text" :to="({ name: 'ImoveisDetalhesFotos', params: { tipo: 'geral', id: $route.params.id } })">Abrir fotos</v-btn>
        </div>
        <v-divider></v-divider>
      </v-card>
    </template>
    <IrParaOTopo></IrParaOTopo>
    <DetalhesFAB :status="status"></DetalhesFAB>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { getAssignedUserId, getAssignedUserName } from '@/utils/assignedUser'
  import HeadersDetalhesResumo from '../Headers/HeadersDetalhesResumo'
  import VistoriaSituacao from '../../Vistoria/VistoriaSituacao'
  import VistoriaRealizar from '../../Vistoria/VistoriaRealizar'
  import TarefasSituacao from '../../Tarefas/TarefasSituacao'
  import TarefasRealizar from '../../Tarefas/TarefasRealizar'
  import IrParaOTopo from '../../Utils/IrParaOTopo'
  import FileIcon from '../../Utils/FileIcon'
  import DetalhesFAB from './DetalhesFAB'
  import moment from 'moment'
  import currencyFormatter from 'currency-formatter'
  import jquery from 'jquery'
  import 'slick-carousel/slick/slick.css'
  import Slick from 'vue-slick'
  import html2pdf from 'html2pdf.js'

  export default {
    components: {
      HeadersDetalhesResumo,
      VistoriaSituacao,
      VistoriaRealizar,
      TarefasSituacao,
      TarefasRealizar,
      IrParaOTopo,
      FileIcon,
      DetalhesFAB,
      jquery,
      Slick
    },
    data () {
      return {
        unsubscribe: null,
        colors: {
          undefined: 'grey',
          Vago: '#EDC109',
          Compromissado: '#EA5DDF',
          Locado: '#4FBF46',
          Comodato: '#006AB6',
          Invadido: '#ED1B09'
        },
        slickOptions: {
          infinite: true,
          variableWidth: true,
          centerMode: false,
          arrows: false
        },
        dialogSubstituirVistoria: false
      }
    },
    mounted () {
      this.$primeUserRestrictions()
      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'imoveis/SET_FILTROS') {
          this.$router.push('/')
        }
      })
    },
    beforeDestroy () {
      this.unsubscribe()
    },
    computed: {
      imovel () {
        return this.$store.getters['imoveis/detalhes']
      },
      currentUser () {
        if (!this.$auth || typeof this.$auth.user !== 'function') return null
        return this.$auth.user()
      },
      currentUserId () {
        const user = this.currentUser || {}
        return user.id || null
      },
      isLimitadoTarefas () {
        return this.$hasUserRestrictionFlag('limitado_tarefas')
      },
      tarefas () {
        const tarefas = this.$store.getters['imoveis/tarefasPendentes']
        if (!this.isLimitadoTarefas) {
          return tarefas
        }

        return tarefas.filter((item) => this.isTaskAssignedToCurrentUser(item))
      },
      showVistoriaColumn () {
        return this.showVistoriaEmptyState || this.canShowVistoriaCard
      },
      showVistoriaEmptyState () {
        return this.$hasGranularPermission('vistoria', 'view') && !this.isLimitadoTarefas && this.vistoria.length < 1
      },
      canShowVistoriaCard () {
        return this.$hasGranularPermission('vistoria', 'view') && this.vistoria.length !== 0
      },
      canCompleteVistoria () {
        return this.normalizeId(this.vistoriaUserId()) === this.normalizeId(this.currentUserId) && !this.vistoria.realizada && this.vistoria.situacao !== 'em dia'
      },
      canAddVistoria () {
        return !this.isLimitadoTarefas && this.$hasGranularPermission('vistoria', 'add')
      },
      canAddTask () {
        return !this.isLimitadoTarefas && this.$hasGranularPermission('tarefas', 'add')
      },
      vistoria () {
        if (this.imovel.hasOwnProperty('vistoria')) {
          if (!this.isLimitadoTarefas) {
            return this.imovel.vistoria.data
          }

          return this.isVistoriaAssignedToCurrentUser(this.imovel.vistoria.data) ? this.imovel.vistoria.data : []
        }
        return []
      },
      endereco () {
        let endereco = {
          'Logradouro': _.filter([`${this.imovel.endereco.data.tipo} ${this.imovel.endereco.data.logradouro}`, this.imovel.endereco.data.numero, this.imovel.endereco.data.complemento]).join(', '),
          'Bairro': this.imovel.endereco.data.bairro,
          'CEP': (this.imovel.endereco.data.cep ? `CEP: ${this.imovel.endereco.data.cep}` : null),
          'Cidade': _.filter([this.imovel.endereco.data.cidade, this.imovel.endereco.data.uf]).join(' - '),
          'observacoes': (this.imovel.observacoes ? _.filter(this.imovel.observacoes.data, { tipo: 'endereco' }) : []),
          'anexos': (this.imovel.anexos ? _.filter(this.imovel.anexos.data, { tipo: 'endereco' }) : [])
        }

        return endereco
      },
      coords () {
        return {
          lat: (this.imovel.endereco ? this.imovel.endereco.data.latitude : null),
          lng: (this.imovel.endereco ? this.imovel.endereco.data.longitude : null)
        }
      },
      loteamento () {
        if (!this.imovel.endereco.data.loteamento) {
          return false
        }
        let loteamento = {
          'Nome': this.imovel.endereco.data.loteamento_nome,
          'Lote': (this.imovel.endereco.data.loteamento_lote ? `Lote ${this.imovel.endereco.data.loteamento_lote}` : null),
          'Quadra': (this.imovel.endereco.data.loteamento_quadra ? `Quadra ${this.imovel.endereco.data.loteamento_quadra}` : null)
        }
        loteamento = _.omitBy(loteamento, _.isEmpty)

        return loteamento
      },
      registro () {
        let registro = {
          'Matrícula': this.imovel.registro.data.matricula,
          'Transcrição': this.imovel.registro.data.transcricao,
          'Cartório': this.imovel.registro.data.cartorio
        }
        registro = _.omitBy(registro, _.isEmpty)

        registro['observacoes'] = (this.imovel.observacoes ? _.filter(this.imovel.observacoes.data, { tipo: 'registro' }) : [])
        registro['anexos'] = (this.imovel.anexos ? _.filter(this.imovel.anexos.data, { tipo: 'registro' }) : [])

        return registro
      },
      area () {
        return {
          'Área do terreno': (this.imovel.area.data.area_terreno > 0 ? `${String(this.imovel.area.data.area_terreno).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')}  m²` : ''),
          'Área construída': (this.imovel.area.data.area_construida > 0 ? `${String(this.imovel.area.data.area_construida).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')}  m²` : ''),
          'Área útil': (this.imovel.area.data.area_util > 0 ? `${String(this.imovel.area.data.area_util).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')}  m²` : ''),
          'Calçada': (this.imovel.area.data.calcada ? 'Com' : 'Sem'),
          'Muro': (this.imovel.area.data.muro ? 'Com' : 'Sem'),
          'observacoes': (this.imovel.observacoes ? _.filter(this.imovel.observacoes.data, { tipo: 'area' }) : []),
          'anexos': (this.imovel.anexos ? _.filter(this.imovel.anexos.data, { tipo: 'area' }) : [])
        }
      },
      taxas () {
        if (this.imovel.hasOwnProperty('taxas')) {
          return {
            'lista': this.imovel.taxas.data,
            'observacoes': (this.imovel.observacoes ? _.filter(this.imovel.observacoes.data, { tipo: 'taxas' }) : []),
            'anexos': (this.imovel.anexos ? _.filter(this.imovel.anexos.data, { tipo: 'taxas' }) : [])
          }
        } else {
          return {
            'lista': []
          }
        }
      },
      valor () {
        return {
          'Valor (est.)': (this.imovel.valor.data.estimativa_valor > 0 ? currencyFormatter.format(this.imovel.valor.data.estimativa_valor, { code: 'BRL' }) : ''),
          'Data da estimativa': (this.imovel.valor.data.estimativa_data.length > 0 ? moment(this.imovel.valor.data.estimativa_data).format('DD/MM/YYYY') : ''),
          'Valor m²/região': (this.imovel.valor.data.regiao_valor > 0 ? currencyFormatter.format(this.imovel.valor.data.regiao_valor, { code: 'BRL' }) : ''),
          'observacoes': (this.imovel.observacoes ? _.filter(this.imovel.observacoes.data, { tipo: 'valor' }) : []),
          'anexos': (this.imovel.anexos ? _.filter(this.imovel.anexos.data, { tipo: 'valor' }) : [])
        }
      },
      status () {
        let result = {
          'status': (this.imovel.status ? this.imovel.status.data.status : ''),
          'observacoes': (this.imovel.observacoes ? _.filter(this.imovel.observacoes.data, { tipo: 'status' }) : []),
          'anexos': (this.imovel.anexos ? _.filter(this.imovel.anexos.data, { tipo: 'status' }) : [])
        }

        if (result.status === 'Vago') {
          result['Placa'] = (this.imovel.status.data.vago_com_placa ? 'Com placa' : 'Sem placa')
          result['Nível de segurança'] = this.imovel.status.data.vago_seguranca
          result['Observações de segurança'] = this.imovel.status.data.vago_seguranca_observacoes
        }

        if (result.status === 'Compromissado') {
          result['Comprador'] = this.imovel.status.data.compromissado_comprador
          result['Data do compromisso'] = (this.imovel.status.data.compromissado_data ? moment(this.imovel.status.data.compromissado_data).format('DD/MM/YYYY') : '')

          if (this.imovel.status.data.compromissado_condicao) {
            result['divider-3'] = true
            result['Condição'] = this.imovel.status.data.compromissado_condicao
            if (this.imovel.status.data.compromissado_condicao === 'Inadimplente') {
              result['Data da inadimplência'] = (this.imovel.status.data.compromissado_inadimplente_data ? moment(this.imovel.status.data.compromissado_inadimplente_data).format('DD/MM/YYYY') : '')
            }
            if (this.imovel.status.data.compromissado_condicao === 'Inadimplente ajuizado') {
              result['Cliente/caso'] = this.imovel.status.data.compromissado_ajuizado_cliente
              result['Processo/execução'] = this.imovel.status.data.compromissado_ajuizado_processo
            }
          }
        }

        if (result.status === 'Locado') {
          if (this.$auth.check('Administrador')) {
            result['Índice'] = (this.imovel.status.data.locado_indice ? this.imovel.status.data.locado_indice : 'Faltam dados')
          }

          if (
            this.imovel.status.data.locado_locador ||
            this.imovel.status.data.locado_locatario ||
            this.imovel.status.data.locado_valor ||
            this.imovel.status.data.locado_valor_data ||
            this.imovel.status.data.locado_inicio_data ||
            this.imovel.status.data.locado_fim_data
          ) {
            result['divider-1'] = true
            result['Locador'] = this.imovel.status.data.locado_locador
            result['Locatário'] = this.imovel.status.data.locado_locatario
            result['Valor do aluguel'] = (this.imovel.status.data.locado_valor > 0 ? currencyFormatter.format(this.imovel.status.data.locado_valor, { code: 'BRL' }) : '')
            result['Data do valor do aluguel'] = (this.imovel.status.data.locado_valor_data ? moment(this.imovel.status.data.locado_valor_data).format('DD/MM/YYYY') : '')
            result['Data do contrato início'] = (this.imovel.status.data.locado_inicio_data ? moment(this.imovel.status.data.locado_inicio_data).format('DD/MM/YYYY') : '')
            result['Data do contrato fim'] = (this.imovel.status.data.locado_fim_data ? moment(this.imovel.status.data.locado_fim_data).format('DD/MM/YYYY') : '')
          }

          if (this.imovel.status.data.locado_acao_renovatoria) {
            result['divider-2'] = true
            result['Ação renovatória'] = this.imovel.status.data.locado_acao_renovatoria_numero
            result[' Cliente/caso'] = this.imovel.status.data.locado_acao_renovatoria_cliente
          }

          if (this.imovel.status.data.locado_condicao) {
            result['divider-3'] = true
            result['Condição'] = this.imovel.status.data.locado_condicao
            if (this.imovel.status.data.locado_condicao === 'Inadimplente') {
              result['Data da inadimplência'] = (this.imovel.status.data.locado_inadimplente_data ? moment(this.imovel.status.data.locado_inadimplente_data).format('DD/MM/YYYY') : '')
            }
            if (this.imovel.status.data.locado_condicao === 'Inadimplente ajuizado') {
              result['Cliente/caso'] = this.imovel.status.data.locado_ajuizado_cliente
              result['Processo/execução'] = this.imovel.status.data.locado_ajuizado_processo
            }
          }
        }

        if (result.status === 'Comodato') {
          result['Nome'] = this.imovel.status.data.comodato_nome
          result['RG'] = this.imovel.status.data.comodato_rg
          result['CPF'] = this.imovel.status.data.comodato_cpf
          result['Telefone'] = (this.imovel.status.data.comodato_telefone && this.imovel.status.data.comodato_telefone.length > 0 ? this.imovel.status.data.comodato_telefone : '')
        }

        if (result.status === 'Invadido') {
          if (this.imovel.status.data.invadido_data) {
            result['Data estimada da invasão'] = (this.imovel.status.data.invadido_data ? moment(this.imovel.status.data.invadido_data).format('DD/MM/YYYY') : '')
            result['divider-1'] = true
          }

          result['Nome'] = this.imovel.status.data.invadido_nome
          result['RG'] = this.imovel.status.data.invadido_rg
          result['CPF'] = this.imovel.status.data.invadido_cpf
          result['Telefone'] = (this.imovel.status.data.invadido_telefone && this.imovel.status.data.invadido_telefone.length > 0 ? this.imovel.status.data.invadido_telefone : '')

          if (this.imovel.status.data.invadido_condicao) {
            result['divider-3'] = true
            result['Condição'] = this.imovel.status.data.invadido_condicao
            if (this.imovel.status.data.invadido_condicao === 'Ocupado ajuizado') {
              result['Cliente/caso'] = this.imovel.status.data.invadido_ajuizado_cliente
              result['Processo/execução'] = this.imovel.status.data.invadido_ajuizado_processo
            }
          }
        }

        return result
      },
      anotacoes () {
        if (this.imovel.hasOwnProperty('observacoes')) {
          return _.filter(this.imovel.observacoes.data, { tipo: 'geral' })
        } else {
          return []
        }
      },
      anexos () {
        if (this.imovel.hasOwnProperty('anexos')) {
          return _.filter(this.imovel.anexos.data, { tipo: 'geral' })
        } else {
          return []
        }
      },
      fotos () {
        if (this.imovel.hasOwnProperty('fotos')) {
          return _.filter(this.imovel.fotos.data, (item) => {
            return item.tipo !== 'ilustrativa'
          })
        } else {
          return []
        }
      },
      ilustrativas () {
        if (this.imovel.hasOwnProperty('fotos')) {
          return _.filter(this.imovel.fotos.data, { tipo: 'ilustrativa' })
        } else {
          return []
        }
      }
    },
    methods: {
      normalizeId (value) {
        if (value === null || typeof value === 'undefined' || value === '') return null
        return String(value)
      },
      vistoriaUserId () {
        return getAssignedUserId(this.vistoria)
      },
      vistoriaUserName () {
        return getAssignedUserName(this.vistoria)
      },
      isVistoriaAssignedToCurrentUser (item) {
        return this.normalizeId(getAssignedUserId(item)) === this.normalizeId(this.currentUserId)
      },
      taskUserId (item) {
        return getAssignedUserId(item)
      },
      taskUserName (item) {
        return getAssignedUserName(item)
      },
      isTaskAssignedToCurrentUser (item) {
        return this.normalizeId(this.taskUserId(item)) === this.normalizeId(this.currentUserId)
      },
      download () {
        this.$store.dispatch('utils/showLoading')
        html2pdf(document.getElementById('save-as-pdf'), {
          margin: 2,
          filename: `${this.imovel.apelido} - ${moment().format('DD.MM.YYYY')}.pdf`,
          pagebreak: {
            avoid: 'p'
          },
          image: {
            type: 'jpeg',
            quality: 1
          },
          html2canvas: {
            dpi: 144,
            scale: 2,
            windowWidth: 2
          },
          jsPDF: {
            format: 'a4',
            orientation: 'p'
          }
        }).then(() => {
          this.$store.dispatch('utils/hideLoading')
        })
      },
      substituirVistoria (event) {
        if (this.imovel.hasOwnProperty('vistoria')) {
          this.dialogSubstituirVistoria = true
        } else {
          this.$router.push({ name: 'VistoriaAdicionar', params: { id: this.$route.params.id } })
        }
      },
      getIcon () {
        /* eslint-disable */
        let fillColor = this.colors.undefined
        if (this.imovel.status !== undefined) {
          fillColor = this.colors[this.imovel.status.data.status]
        }

        return {          
          path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
          fillColor: fillColor,
          fillOpacity: 1,
          strokeColor: '#FFFFFF',
          strokeWeight: 1,
          scale: 1
        }
        /* eslint-enable */
      }
    }
  }
</script>

<style scoped>
.slick-slider { cursor: move; margin-bottom: -7px; margin-top: 9px; }
.slick-slider img { padding-right: 7px; }
.layout.row.vistoria-tarefas-layout { flex-wrap: nowrap !important; }
.px-5 > .card__text > .layout.row.wrap { flex-wrap: nowrap !important; }

@media (max-width: 599px) {
  .layout.row.vistoria-tarefas-layout { flex-wrap: wrap !important; }

  .px-5 > .card__text > .layout.row.wrap {
    flex-wrap: wrap !important;
    align-items: center;
  }

  .px-5 > .card__text > .layout.row.wrap > div:first-child {
    display: flex;
    align-items: center;
    flex: 0 0 24px;
    max-width: 24px;
    margin-right: 8px;
    margin-bottom: 0;
  }

  .px-5 > .card__text > .layout.row.wrap > div:first-child + .flex.xs12 {
    flex: 1 1 calc(100% - 36px);
    max-width: calc(100% - 36px);
  }

  .px-5 .card__text p {
    margin-bottom: 2px;
  }

  .px-5 {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .pr-5,
  .pl-5 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .borda_imoveis {
    display: none;
  }
}
</style>

<style>
  @media print {
    .hide-pdf { display: none !important; }
    
    .btn { display: none; }
    .borda_imoveis { display: none; }

    .toolbar { background: none !important; color: black; }
    .toolbar h1 { color: black; }

    .px-5 { padding-left: 10px !important; padding-right: 10px !important; }
  }
</style>



// WEBPACK FOOTER //
// DetalhesResumo.vue?ef0871d8